import ArticleLayout from '@/components/feature/ArticleLayout';

export default function TshirtsArticle() {
  return (
    <>
      <title>Superbuy Spreadsheet T-Shirts: The Complete Guide to Finding Quality Tees &amp; Graphic Shirts</title>
      <meta name="description" content="Complete guide to Superbuy Spreadsheet t-shirts — discover heavyweight tees, graphic shirts, vintage washes, and premium basics. Fabric weight guide, fit comparison tips, QC evaluation, and curated tee finds for 2026." />
      <meta name="keywords" content="superbuy spreadsheet t-shirts, superbuy sheet tshirts, superbuy tee spreadsheet, best superbuy tshirts, superbuy graphic tee guide, superbuy spreadsheet basics, superbuy heavyweight tshirt" />
      <link rel="canonical" href={`${import.meta.env.VITE_SITE_URL || 'https://superbuyspread.makeup'}/superbuy-spreadsheet-tshirts`} />
      <ArticleLayout slug="superbuy-spreadsheet-tshirts" />
    </>
  );
}